import { z } from 'zod';

export const SweetShopArticleElementModelSchema = z.object({
    name: z.string(),
    value: z.number(),
    meassure: z.string(),
});

export type SweetShopArticleElementModel
= z.infer<typeof SweetShopArticleElementModelSchema>;
